import { NetworkMode } from "@tanstack/react-query";
import { Duration } from "date-fns";
import { EncryptStorage } from "encrypt-storage";
import packageFile from "~/package.json";
import { getFingerprint } from "~/src/helpers/fingerprint";

export const appId = packageFile.name;

const fingerprint = getFingerprint();
export const secureLocalStorage = new EncryptStorage(fingerprint, {
  storageType: "localStorage",
  prefix: "@enc",
  doNotParseValues: true,
});

/**
 * Global and environment-specific config (utv, prod, feature, etc.)
 */
export type AppConfig = {
  environment: string;
  jaktdataApiBaseUrl: string;
  networkTimeoutLimit: Duration;
  networkDegradedTimeoutLimit: Duration;
  reactQuery: {
    defaultStaleTime: Duration; // hvor lenge query resultater er gyldig før de invalideres
    defaultGCTime: number;
    networkMode: NetworkMode;
    maxRetries: number;
  };
  urls: {
    personvernerklaering: string;
  };
};

const defaultConfig: AppConfig = {
  environment: import.meta.env.VITE_ENVIRONMENT,
  jaktdataApiBaseUrl: import.meta.env.VITE_API_URL,
  networkTimeoutLimit: { seconds: 4 },
  networkDegradedTimeoutLimit: { seconds: 2 },
  reactQuery: {
    defaultStaleTime: { seconds: 60 },
    defaultGCTime: Infinity,
    networkMode: "always",
    maxRetries: 3,
  },
  urls: {
    personvernerklaering: "https://www.hjorteviltregisteret.no/personvern",
  },
};

export const appConfig = defaultConfig;

export const getEnvironmentLabel = (): string | undefined =>
  (import.meta.env.VITE_API_URL as string).match(/hvr-([^.]+)/)?.[1];

